import * as THREE from 'three'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'

export default class AssetLoader {
  constructor() {
    this.textureLoader = new THREE.TextureLoader()
    this.gltfLoader = new GLTFLoader()
    this.cubeTextureLoader = new THREE.CubeTextureLoader()
  }

  loadTexture(path, onLoad) {
    return this.textureLoader.load(path, onLoad)
  }

  loadGLTF(path, onLoad) {
    return this.gltfLoader.load(path, onLoad)
  }

  loadCubeMap(paths, onLoad) {
    return this.cubeTextureLoader.load(paths, onLoad)
  }
}
